import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { History as HistoryIcon, Trash2, Search as SearchIcon } from "lucide-react";

export default function HistoryPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [filter, setFilter] = useState("");
  const [load, setLoad] = useState(true);

  useEffect(() => {
    if (loading) return;
    if (!user || user === false) { navigate("/login", { state: { from: "/history" } }); return; }
    api.get("/history").then(({ data }) => setHistory(data)).finally(() => setLoad(false));
  }, [user, loading, navigate]);

  const clearAll = async () => {
    if (!window.confirm("Tout effacer ?")) return;
    await api.delete("/history");
    setHistory([]);
  };
  const remove = async (id) => {
    await api.delete(`/history/${id}`);
    setHistory((h) => h.filter((x) => x.id !== id));
  };

  const filtered = history.filter((h) => h.query.toLowerCase().includes(filter.toLowerCase()));

  if (loading || !user || user === false) return null;
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 py-12" data-testid="history-page">
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight flex items-center gap-3 mb-2">
          <HistoryIcon size={28} /> Historique
        </h1>
        <p className="text-sm text-gray-500 mb-6">Vos {history.length} dernières recherches.</p>

        <div className="flex gap-2 mb-6">
          <Input placeholder="Filtrer l'historique…" value={filter} onChange={(e) => setFilter(e.target.value)} className="max-w-md" data-testid="history-filter-input" />
          {history.length > 0 && (
            <Button onClick={clearAll} variant="outline" className="text-red-600 rounded-full" data-testid="clear-all-history-btn">
              <Trash2 size={15} className="mr-1" /> Tout effacer
            </Button>
          )}
        </div>

        {load && <div className="text-gray-500">Chargement…</div>}
        {!load && filtered.length === 0 && (
          <div className="border border-dashed border-[var(--omni-border)] rounded-lg p-12 text-center text-gray-500">
            {history.length === 0 ? "Aucun historique." : "Aucun résultat pour ce filtre."}
          </div>
        )}

        <ul className="divide-y divide-[var(--omni-border)] border border-[var(--omni-border)] rounded-lg overflow-hidden">
          {filtered.map((h) => (
            <li key={h.id} className="flex items-center justify-between px-4 py-3 hover:bg-[var(--omni-surface)]" data-testid={`history-row-${h.id}`}>
              <Link to={`/search?q=${encodeURIComponent(h.query)}&type=${h.type}`} className="flex items-center gap-3 flex-1 min-w-0">
                <SearchIcon size={15} className="text-gray-400" />
                <span className="truncate">{h.query}</span>
                <span className="text-xs uppercase font-mono text-gray-400 ml-2">{h.type}</span>
              </Link>
              <span className="text-xs text-gray-400 mx-4 hidden sm:inline">{new Date(h.created_at).toLocaleString()}</span>
              <button onClick={() => remove(h.id)} className="text-gray-400 hover:text-red-600" data-testid={`history-row-delete-${h.id}`}>
                <Trash2 size={15} />
              </button>
            </li>
          ))}
        </ul>
      </main>
      <Footer />
    </div>
  );
}
